import logger from "@next/core-logger"
import {DEFAULT_TEMPLATE} from "../../config/constants"
import {TemplateSettingsDuckState} from "../../models/templates"

export const getTemplateSettings = (template: string, templatesConfig: TemplateSettingsDuckState | null) => {
    if (!template) logger.warn("No Template Value defined from Feature Settings")
    let mainTemplate = DEFAULT_TEMPLATE
    let fallbackTemplate = DEFAULT_TEMPLATE

    if (!templatesConfig) {
        logger.warn("No templatesConfigettings defined")
        return {mainTemplate, fallbackTemplate}
    }
    const identifiedTemplate = templatesConfig[template]

    if (identifiedTemplate) {
        mainTemplate = template
        if (identifiedTemplate.fallback) {
            fallbackTemplate = identifiedTemplate.fallback
        }
    } else {
        logger.warn(`No Template for ${template} defined in templatesConfigettings`)
    }

    return {mainTemplate, fallbackTemplate}
}

export default getTemplateSettings
